import React from 'react';

export default function F10FrontPage() {
    return <img style={{ marginLeft: 'auto', marginRight: 'auto', width: '300px', height: 'auto' }} src="/assets/img/f10/logo-2.png" />;
}
